"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { useAui, AuiProvider, Derived } from "@assistant-ui/store";
export const PartByIndexProvider = ({ index, children }) => {
    const aui = useAui({
        part: Derived({
            source: "message",
            query: { type: "index", index },
            get: (aui) => aui.message().part({ index }),
        }),
    });
    return _jsx(AuiProvider, { value: aui, children: children });
};
//# sourceMappingURL=PartByIndexProvider.js.map